import template from './segmented-button.html';

class SegmentedButtonComponent {

  $onInit() {
    this.options.forEach(option => {
      if (!option.class) {
        option.class = 'seg-button-default';
      }
    });
    if (this.size !== 'xs' && this.size !== 'sm' && this.size !== 'lg') {
      this.btnSize = 'md';
    } else {
      this.btnSize = this.size;
    }

    this.ngModelCtrl.$render = () => {
      this.value = this.ngModelCtrl.$viewValue;
    };
  }

  select(option) {
    if (this.value === option.value) {
      return;
    }

    this.value = option.value;
    this.ngModelCtrl.$setViewValue(this.value);
  }
}

export default {
  bindings: {
    options: '<',
    size: '@'
  },
  require: {
    ngModelCtrl: 'ngModel'
  },
  template,
  controller: SegmentedButtonComponent
};